module.exports = __webpack_public_path__ + "img/KeyPal-Card.ae73156c.png";